//import libraries
import { Component, OnInit, AfterViewInit, TemplateRef, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

//import constants
import { AppSettings } from '../../../../constants/app-settings';
import { AppPermissions } from '../../../../constants/app-permission';
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

import { GeneralService } from '../../../../services/general.service';
import { NotificationService } from '../../../../services/notification.service';
import { CustomersService } from '../../../../services/customers.service';
import { ConsultancyService } from '../../../../services/consultancy.service';
import { ScheduledCoursesService } from '../../../../services/scheduled_courses.service';
import { EmployeeService } from '../../../../services/employee.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { formatDate } from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-scheduled_courses_create',
  templateUrl: './scheduled_courses_create.component.html',
  styleUrls: ['./scheduled_courses_create.component.css']
})
export class CreateScheduleCourseComponent implements OnInit, AfterViewInit {

  readonly AppSettings = AppSettings;
  readonly AppPermissions = AppPermissions;
  readonly AppFrontRoutes = AppFrontRoutes;
  @Input() ID: string;
  @Input() lang: any;
  @Input() data: any;
  @Input() selectedData: any;
  typeConfig: any;
  planConfig: any;
  emp_id: any;
  modalTitle: string;
  maintenance_plans: any;
  app_maintenance_plans: any;
  app_emp_id: any;
  // lang: any;
  generalLang: any;
  record: any;
  mode: string;
  courseType: any;
  contractType: any;

  imageLink: any;
  // data: any;
  skills_places: any;
  skills_places1: any;
  course: any;
  course_m: any;
  edit_data: any;
  id: any;
  contract_type: any;

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  catloqCode;
  modules;
  selectedTeachers;
  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private notificationService: NotificationService,
    private consultancyService: ConsultancyService,    
    private customersService: CustomersService,
    private scheduledCoursesService: ScheduledCoursesService,    
    public bsModalRef: BsModalRef,
    private route: ActivatedRoute,
    private employeeService: EmployeeService,
    private router: Router) { }

  ngOnInit() {
    //fetch data
    // this.data = this.route.snapshot.data['data'];
 
    //tab1 actions
    this.getData();

    this.config();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };


  }

  ngAfterViewInit(): void {
    let tab = this.route.snapshot.paramMap.get('tab');

    if (tab)
      $('.nav-tabs a[href="#settingsTab"]').tab('show');

  }



  config(): void {
    // console.log(this.lang);

  }


  stringToDate(_date,_format,_delimiter)
  {
      var formatLowerCase=_format.toLowerCase();
      var formatItems=formatLowerCase.split(_delimiter);
      var dateItems=_date.split(_delimiter);
      var monthIndex=formatItems.indexOf("mm");
      var dayIndex=formatItems.indexOf("dd");
      var yearIndex=formatItems.indexOf("yyyy");
      var month=parseInt(dateItems[monthIndex]);
      month-=1;
      var formatedDate = new Date(dateItems[yearIndex],month,dateItems[dayIndex]);
      return formatedDate;
  }
  

  getCatloqCode(value){
    let courseId = (this.selectedData && this.selectedData.scheduled_courseId)?this.selectedData.scheduled_courseId:0;
    this.scheduledCoursesService.getCatloqData(value,courseId).subscribe(response => { 
      console.log(response.data)
      
      this.selectedTeachers = response.data[0].modules[0].teacher;
      const arr = <FormArray>this.createForm.controls.sc_courses;
      arr.controls = [];

      if(this.selectedData && this.selectedData.scheduled_courseId){
        this.modules = response.data[0].modules;
        for(let data of response.data.sc_single_module){
          console.log(data.scm_start_date)
          console.log(this.stringToDate(data.scm_start_date,'mm-dd-yyyy','-'))
          let add = this.createForm.get('sc_courses') as FormArray;
          add.push(
            this.formBuilder.group({
              no_modle: [data.scm_num_module, [Validators.required]],
              mod_arg: [data.scm_arguments, [Validators.required]],
              mod_durat: [data.scm_duration, [Validators.required]],
              teacher_name: [data.scm_teacher, [Validators.required]],
              
              start_date: [formatDate(this.stringToDate(data.scm_start_date,'mm-dd-yyyy','-'), 'yyyy-MM-dd', 'en'), [Validators.required]],
              end_date: [formatDate(this.stringToDate(data.scm_end_date,'mm-dd-yyyy','-'), 'yyyy-MM-dd', 'en'), [Validators.required]],
              exec_dates: [formatDate(this.stringToDate(data.exec_dates,'mm-dd-yyyy','-'), 'yyyy-MM-dd', 'en'), [Validators.required]],
          })
        )
        // for(let teacher of data.teacher){
        //   console.log(teacher)
        // }

      }
      }else{
        this.modules = response.data[0].modules;
        for(let data of this.modules){
          console.log(data)
          let add = this.createForm.get('sc_courses') as FormArray;
          add.push(
            this.formBuilder.group({
              no_modle: [data.catalog_moduleId, [Validators.required]],
              mod_arg: [data.module_arguments, [Validators.required]],
              mod_durat: [data.module_duration, [Validators.required]],
              teacher_name: ['', [Validators.required]],
              start_date: ['', [Validators.required]],
              end_date: ['', [Validators.required]],
              exec_dates: ['', [Validators.required]],
          })
        )
        // for(let teacher of data.teacher){
        //   console.log(teacher)
        // }

      }
      }
      


      


      this.createForm.patchValue({
        "sc_course_name": response.data[0].d1,
        "sc_course_catgy": response.data[0].d2,
        "sc_duration": response.data[0].d3,
      })
    })
  }

  getTeachers(index){
    return (this.modules && this.modules[index])?this.modules[index].teacher:[];
  }

  FormBuild(): void {

    this.createForm = this.formBuilder.group({
      sc_couse_code: ['', [Validators.required]],
      sc_course_name: ['', [Validators.required]],
      sc_course_catgy: ['', [Validators.required]],
      sc_duration: ['', [Validators.required]],
      place_perf: ['', [Validators.required]],
      act_body: ['', [Validators.required]],
      sc_catalog_code:['', [Validators.required]],
      sc_teacher_name:['', [Validators.required]],
      sched_staus:['', [Validators.required]],
      sc_courses: this.formBuilder.array([]),
      cid: '',
      submit: 'update',
    });


  }



  FormBuildUpdate(): void {
    console.log("==== Data ========")
    console.log(this.selectedData)
    this.createForm.patchValue({
      sc_couse_code: this.selectedData.course_code,
      sc_course_name: this.selectedData.description,
      sc_course_catgy: this.selectedData.sc_course_catgy,
      sc_duration: this.selectedData.m_drtn,
      place_perf: this.selectedData.place_perf,
      act_body: this.selectedData.act_body,
      sc_catalog_code:this.selectedData.sc_catalog_code,
      sc_teacher_name:this.selectedData.qualified_teacheName,
      sched_staus:this.selectedData.sc_sched_status,
      cid: this.selectedData.scheduled_courseId,
    });

    this.getCatloqCode(this.selectedData.sc_catalog_code)

  }


  formErrorClass(value, submitted): string {
    return value && value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }



  onSubmit() {
    this.createFormSubmitted = true;
    console.log(this.createForm); 
    if (this.createForm.invalid)
      return;

    // console.log('test12'); return false;

    this.scheduledCoursesService.addEditScheduledCourse(this.createForm.value).subscribe(
      res => {

        if (res.status) {
          this.generalService.notify_msg('success', res.msg);

          if (res.action == 'insert') {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.SCHEDULEDCOURSES]);
              });
          } else {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.SCHEDULEDCOURSES]);
            });
          }
          this.bsModalRef.hide();
        }
        else {
          this.generalService.notify_msg('error', res.data);
        }

      }
    );

  }

  getData() {
    this.FormBuild();
    this.createFormErrorMsg = {
      'sc_couse_code': [{ type: 'required', message: this.lang.requiredField }],
      'sc_course_name': [{ type: 'required', message: this.lang.requiredField }],
      'sc_course_catgy': [{ type: 'required', message: this.lang.requiredField }],
      'sc_duration': [{ type: 'required', message: this.lang.requiredField }],
      'place_perf': [{ type: 'required', message: this.lang.requiredField }],
      'act_body': [{ type: 'required', message: this.lang.requiredField }],
      'sc_catalog_code': [{ type: 'required', message: this.lang.requiredField }],
      'sc_teacher_name': [{ type: 'required', message: this.lang.requiredField }],
      'sched_staus': [{ type: 'required', message: this.lang.requiredField }],
    }

    if(this.selectedData)  this.FormBuildUpdate()

    console.log("===== Create Message =======")
    console.log(this.createFormErrorMsg)

  }
}
